import React from 'react';
import { C, S } from '../../utils/styles';
import { fmt } from '../../utils/formatters';
import Icon from '../Icon';

export default function IBOSComparison({ aggregates }) {
  const s125 = aggregates?.bySection125 || { employerSavings: 0, employeeValue: 0, total: 0 };
  const full = aggregates?.byFullIBOS || { employerSavings: 0, employeeValue: 0, total: 0 };
  const current = {
    employerSavings: aggregates?.employerSavings || 0,
    employeeValue: aggregates?.employeeValue || 0,
    total: aggregates?.total || 0,
  };
  const multiplier = s125.total > 0 ? (full.total / s125.total) : 0;

  return (
    <div data-testid="ibos-comparison" style={{ ...S.card, padding: 0, overflow: 'hidden' }}>
      <div style={{ padding: '16px 20px', borderBottom: `1px solid ${C.border}` }}>
        <h3 style={{ ...S.heading, margin: 0 }}>Current vs IBOS Comparison</h3>
      </div>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={S.th}>&nbsp;</th>
              <th style={{ ...S.th, textAlign: 'right' }}>No Program</th>
              <th style={{ ...S.th, textAlign: 'right' }}>Section 125 Only</th>
              <th style={{ ...S.th, textAlign: 'right', color: C.accent }}>Full IBOS</th>
              <th style={{ ...S.th, textAlign: 'right' }}>Current (enabled)</th>
            </tr>
          </thead>
          <tbody>
            <Row label="Employer FICA / Savings" a={0} b={s125.employerSavings} c={full.employerSavings} d={current.employerSavings} color={C.blue} />
            <Row label="Employee Take-Home / Value" a={0} b={s125.employeeValue} c={full.employeeValue} d={current.employeeValue} color={C.green} />
            <Row label="Total Annual Value" a={0} b={s125.total} c={full.total} d={current.total} color={C.accent} bold />
          </tbody>
        </table>
      </div>
      {multiplier > 0 && (
        <div style={{ padding: '14px 20px', background: C.accentBg, borderTop: `1px solid ${C.accentLight}` }}>
          <div style={{ fontSize: 12, color: C.textMid }}>
            <Icon name="trending-up-outline" style={{ fontSize: 14, color: C.accent, marginRight: 6, verticalAlign: 'middle' }} />
            The full IBOS delivers <strong style={{ color: C.accent }}>{multiplier.toFixed(1)}x</strong> more total value than Section 125 alone.
          </div>
        </div>
      )}
    </div>
  );
}

function Row({ label, a, b, c, d, color, bold }) {
  const weight = bold ? 800 : 600;
  return (
    <tr>
      <td style={{ ...S.td, fontWeight: weight, color: C.text }}>{label}</td>
      <td style={{ ...S.td, ...S.mono, textAlign: 'right', color: C.textLight, fontWeight: weight }}>{fmt(a)}</td>
      <td style={{ ...S.td, ...S.mono, textAlign: 'right', color: C.textMid, fontWeight: weight }}>{fmt(b)}</td>
      <td style={{ ...S.td, ...S.mono, textAlign: 'right', color, fontWeight: weight }}>{fmt(c)}</td>
      <td style={{ ...S.td, ...S.mono, textAlign: 'right', color: C.textMid, fontWeight: weight }}>{fmt(d)}</td>
    </tr>
  );
}
